import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-fdff519e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = {
  style: {
    "display": "inline-block"
  }
};
const _hoisted_3 = {
  style: {
    "font-size": "22px",
    "vertical-align": "bottom",
    "margin": "0 30px 0 3px"
  }
};
const _hoisted_4 = {
  style: {
    "float": "right",
    "margin": "2px 10px 0 10px"
  }
};
const _hoisted_5 = {
  key: 0,
  style: {
    "display": "inline-block"
  }
};
const _hoisted_6 = {
  key: 1,
  style: {
    "display": "inline-block",
    "line-height": "30px",
    "vertical-align": "top"
  }
};
const _hoisted_7 = {
  class: "time"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mydialogtitle"
}, "提示信息", -1));

const _hoisted_9 = {
  class: "dialog-footer"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("确 认");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_color_picker = _resolveComponent("el-color-picker");

  const _component_el_col = _resolveComponent("el-col");

  const _component_marquee = _resolveComponent("marquee");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12,
      style: {
        "text-align": "left"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$store.state.web_name), 1), _createElementVNode("span", _hoisted_4, [_createVNode(_component_el_color_picker, {
        modelValue: $data.color,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.color = $event),
        predefine: $data.predefineColors,
        size: "small",
        "color-format": "hsl",
        onChange: $options.change_color
      }, null, 8, ["modelValue", "predefine", "onChange"])])]), $data.online_status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", null, [_withDirectives(_createElementVNode("span", null, "下级" + _toDisplayString(_ctx.$store.state.watchsub.group_name) + ":" + _toDisplayString(_ctx.$store.state.watchsub.username), 513), [[_vShow, _ctx.$store.state.watchsub_show]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.$store.state.userinfo.group_name) + ":" + _toDisplayString(_ctx.$store.state.userinfo.username), 513), [[_vShow, !_ctx.$store.state.watchsub_show]]), _createElementVNode("span", {
        class: "open-view",
        style: {
          "float": "right"
        },
        onClick: _cache[1] || (_cache[1] = (...args) => $options.go_zijinrizhi && $options.go_zijinrizhi(...args))
      }, "余额(" + _toDisplayString($data.balance) + ")", 1)]), _createElementVNode("div", null, [_createElementVNode("span", {
        class: "open-view",
        onClick: _cache[2] || (_cache[2] = $event => $options.go_tongji(1))
      }, "在线管理(" + _toDisplayString($data.now_users_manager) + ")", 1), _createElementVNode("span", {
        class: "open-view",
        style: {
          "margin": "0 30px"
        },
        onClick: _cache[3] || (_cache[3] = $event => $options.go_tongji(0))
      }, "在线会员(" + _toDisplayString($data.now_users_member) + ")", 1), _createElementVNode("span", {
        class: "open-view",
        onClick: _cache[4] || (_cache[4] = $event => $options.go_tongji(2))
      }, "投注人数(" + _toDisplayString($data.user_bet_count) + ")", 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_withDirectives(_createElementVNode("span", null, "下级" + _toDisplayString(_ctx.$store.state.watchsub.group_name) + ":" + _toDisplayString(_ctx.$store.state.watchsub.username), 513), [[_vShow, _ctx.$store.state.watchsub_show]]), _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.$store.state.userinfo.group_name) + ":" + _toDisplayString(_ctx.$store.state.userinfo.username), 513), [[_vShow, !_ctx.$store.state.watchsub_show]]), _createElementVNode("span", {
        class: "open-view",
        style: {
          "margin-left": "30px"
        },
        onClick: _cache[5] || (_cache[5] = (...args) => $options.go_zijinrizhi && $options.go_zijinrizhi(...args))
      }, "余额(" + _toDisplayString($data.balance) + ")", 1)]))]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_createVNode(_component_marquee, {
        class: "Affiche1",
        id: "Affiche",
        direction: "left",
        scrolldelay: "4",
        scrollamount: "2"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.notice_list, item => {
          return _openBlock(), _createElementBlock("span", {
            key: item.id,
            class: "item"
          }, [_createElementVNode("span", null, _toDisplayString(item.title) + "：", 1), _createElementVNode("span", null, _toDisplayString(item.text), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$filters.time(item.create_time)), 1)]);
        }), 128))]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.dialog.visible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.dialog.visible = $event),
    width: "500px",
    class: "mydialogclass",
    "destroy-on-close": ""
  }, {
    header: _withCtx(() => [_hoisted_8]),
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createVNode(_component_el_button, {
      size: "small",
      type: "warning",
      onClick: _cache[6] || (_cache[6] = $event => $data.dialog.visible = false)
    }, {
      default: _withCtx(() => [_hoisted_10]),
      _: 1
    })])]),
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dialog.list, item => {
      return _openBlock(), _createBlock(_component_el_row, {
        key: item.id,
        class: "item-info",
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8,
          style: {
            "font-weight": "bold",
            "text-align": "center"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("【" + _toDisplayString(item.title) + "】:", 1)]),
          _: 2
        }, 1024), _createVNode(_component_el_col, {
          span: 16
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text) + " （" + _toDisplayString(_ctx.$filters.time(item.create_time)) + "） ", 1)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]);
}